/**
 * PDP FAQ Custom Element
 * Self-initializing, accessible, editor-friendly web component wrapping the accordion.
 */
class PdpFaq extends HTMLElement {
  connectedCallback() {
    this.accordion = this.querySelector('.pdp-faq__accordion');
    if (!this.accordion) return;

    this.items = this.querySelectorAll('.pdp-faq__item');
    this.buttons = this.querySelectorAll('.pdp-faq__question');

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const item = button.closest('.pdp-faq__item');
        const isOpen = item.classList.contains('is-open');

        // Close all items
        this.items.forEach((el) => {
          el.classList.remove('is-open');
          const btn = el.querySelector('.pdp-faq__question');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
        });

        // Open clicked item if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

if (!customElements.get('pdp-faq')) {
  customElements.define('pdp-faq', PdpFaq);
}
